module.exports = __webpack_public_path__ + "static/media/party.9ee86180.svg";